import React from 'react';
import { FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="bg-[#0B2F2A] text-emerald-50/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-white font-bold text-lg mb-3">
              <span>personalfinance</span><span className="text-[#FCD34D]">care.com</span>
            </h3>
            <p className="text-sm leading-relaxed">Professional subscription management and after-sales support you can trust.</p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-[#FCD34D] transition-colors">Home</a></li>
              <li><a href="/faqs.html" className="hover:text-[#FCD34D] transition-colors">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><FiMail className="w-4 h-4 text-[#FCD34D]" /> support@personalfinancecare.com</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-emerald-50/50">
          &copy; 2026 personalfinancecare.com - All rights reserved.
        </div>
      </div>
    </footer>
  );
}
